(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/input-range/assets/javascripts/input-range-handle.js') >= 0) return;  svs.modules.push('/components/lb-ui/input-range/assets/javascripts/input-range-handle.js');

'use strict';

const _excluded = ["className", "hasIcons", "offset", "onChange"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
const {
  useCallback,
  useEffect,
  useRef,
  useState
} = React;
const {
  ReactIcon
} = svs.ui;
const {
  clx
} = svs.components.lbUtils;
const InputRangeHandle = _ref => {
  let {
      className,
      hasIcons,
      offset,
      onChange
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const startX = useRef(0);
  const [drag, setDrag] = useState(false);
  const handleTouchMove = useCallback(event => {
    const currentTouchX = typeof event.pageX !== 'undefined' ? event.pageX : event.touches[0].pageX;
    requestAnimationFrame(() => onChange(currentTouchX - startX.current));
  }, [onChange]);
  const handleMove = event => {
    if (event.cancelable === true) {
      event.preventDefault();
    }
  };
  const handleTouchEnd = useCallback(() => {
    setDrag(false);
    window.removeEventListener('mouseup', handleTouchEnd);
    window.removeEventListener('touchend', handleTouchEnd);
    window.removeEventListener('mousemove', handleTouchMove);
    window.removeEventListener('touchmove', handleMove);
  }, [handleTouchMove]);
  const handleTouchStart = event => {
    startX.current = (typeof event.pageX !== 'undefined' ? event.pageX : event.touches[0].pageX) - offset;
    setDrag(true);
    window.addEventListener('mousemove', handleTouchMove);
    window.addEventListener('touchmove', handleMove, {
      passive: false
    });
    window.addEventListener('touchend', handleTouchEnd);
    window.addEventListener('mouseup', handleTouchEnd);
  };
  useEffect(() => () => {
    window.removeEventListener('mouseup', handleTouchEnd);
    window.removeEventListener('touchend', handleTouchEnd);
    window.removeEventListener('mousemove', handleTouchMove);
    window.removeEventListener('touchmove', handleMove);
  }, []);
  return React.createElement("button", _extends({
    className: clx('f-200', {
      'input-range-btn-is-active': drag
    }, className),
    "data-testid": "qa-input-range-handle",
    onMouseDown: handleTouchStart,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    onTouchStart: handleTouchStart,
    style: {
      transform: "translateX(".concat(offset, "px)")
    },
    tabIndex: -1,
    type: "button"
  }, props), hasIcons && React.createElement(React.Fragment, null, React.createElement(ReactIcon, {
    color: "fc-white",
    icon: "caret-left"
  }), React.createElement(ReactIcon, {
    color: "fc-white",
    icon: "caret-right"
  })));
};
InputRangeHandle.defaultProps = {
  hasIcons: true,
  offset: 0,
  onChange: () => {}
};
setGlobal('svs.components.lbUi.inputRange.InputRangeHandle', InputRangeHandle);

 })(window);